import { supabase } from "@/integrations/supabase/client";
import { showError, showInfo } from "@/hooks/use-toast";
import { Location } from "@/components/campaign/types";
import { devLog, devError } from "@/utils/secureLogger";

export const sendPaymentConfirmationEmail = async (emailData: any) => {
  devLog('sendPaymentConfirmationEmail stub called');
  return { success: true };
};

export const sendCampaignNotificationEmail = async (emailData: any) => {
  devLog('sendCampaignNotificationEmail stub called');
  return { success: true };
};

export const sendCampaignConfirmationEmail = async (
  campaignId: string,
  formData: any,
  selectedLocations: Location[],
  devices: number,
  startDate: string,
  endDate: string,
  duration: number,
  budgetInfo: any
) => {
  try {
    devLog('=== SENDING CAMPAIGN CONFIRMATION EMAIL ===');
    devLog('Campaign ID:', campaignId);
    
    const budgetCalculations = budgetInfo || JSON.parse(localStorage.getItem(`budgetCalculations_${formData.email}`) || '{}');
    
    const payload = {
      campaignId,
      recipientEmail: formData.email,
      companyName: formData.companyName,
      brandName: formData.brandName,
      personInCharge: formData.personInCharge,
      jobTitle: formData.jobTitle,
      mobile: formData.mobile,
      startDate,
      endDate,
      selectedLocations: selectedLocations.map(loc => ({
        name: loc.name,
        devices: loc.devices || 0
      })),
      totalDevices: devices,
      totalBudget: budgetCalculations.totalBudget || formData.totalBudget || 0,
      budgetCalculations
    };
    
    devLog('=== INVOKING EDGE FUNCTION: send-campaign-email ===');
    
    const { data, error } = await supabase.functions.invoke('send-campaign-email', {
      body: payload
    });
    
    devLog('=== EDGE FUNCTION RESPONSE ===');
    devLog('Email sent successfully:', !!data);
    
    if (error) {
      devError('Error sending campaign confirmation email:', error);
      showError({
        title: "Email Notification",
        description: "We couldn't send you a confirmation email, but your campaign was successfully submitted.",
      });
      return { error };
    }
    
    devLog('Campaign confirmation email sent successfully');
    showInfo({
      title: "Email Sent",
      description: "A confirmation email has been sent to your email address.",
    });
    
    return { success: true };
  } catch (error) {
    devError('Exception in sendCampaignConfirmationEmail:', error);
    return { error };
  }
};